import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-payment-arrangement-report',
  templateUrl: './payment-arrangement-report.component.html',
  styleUrls: ['./payment-arrangement-report.component.scss']
})
export class PaymentArrangementReportComponent implements OnInit {

  constructor(private reportService:ReportService) { }

  ngOnInit(): void {
  }
  generateExcel  () {
    this.reportService.getPaymentArrangeReport().subscribe( (data)=> {
        debugger
        if (data) {
            const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
            const downloadLink = document.createElement('a');
            const fileName = 'Payment Arrangement Report.xls';
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        }
    });

}
}
